const authReducer = (state = { authData: null , message : null }, action) => {
  switch (action.type) {
    case "SIGNIN":

      localStorage.setItem("token", action.payload.token);
      return { ...state, authData: action.payload?.user || "" , message : action?.message };
      case "SIGNUP": 
           localStorage.setItem("token", action.token);
      return { ...state, authData: action?.user , message : action.message };
    case "LOGOUT":
      localStorage.clear();

      return { ...state, authData: null , message : null };

    default:
      return state;
  }
};

export default authReducer;
